import { Navigate } from 'react-router'

import { FORTEM_URIS } from '@/constants/uris'
import { AdminFundsPage } from '@/pages/admin/funds/page'
import { AdminLayout } from '@/pages/admin/layout'
import { CalendarPage } from '@/pages/calendar/page'
import type { CustomRouteObject, FortemRouteHandle } from '@/router'

export const adminRoutes = [
  {
    path: FORTEM_URIS.ADMIN.__INDEX__,
    element: <AdminLayout />,
    handle: {
      title: 'Admin',
    },
    children: [
      {
        path: FORTEM_URIS.ADMIN.FUNDS,
        element: <AdminFundsPage />,
      },
      {
        path: FORTEM_URIS.ADMIN.CALENDAR,
        element: <CalendarPage />,
        handle: { title: 'Calendar' },
      },
    ],
  },
  {
    path: FORTEM_URIS.CALENDAR,
    element: <Navigate to="/admin/calendar" replace />,
  },
] satisfies CustomRouteObject<FortemRouteHandle>[]
